import React from "react";
import Footer from "./components/Footer";
import "../css/About.css";

function About() {
  return (
    <section className="about frosted">
      <h2>COUSCOUS //</h2>
      <h3>Creative Project and Art Platform.</h3>
      <br />
      <div className="about-text">
        <p>What started as the 3 of us not having any direction or purpose to our creativity has grown into this: a year long project and a space for us to share our creative outlets with you.</p>
        <p>While this is a shop, COUSCOUS has always been about something bigger: the process of making, the joy of experimenting and giving ourselves (and others) something to create for.</p>
        <p>Knowing we wanted to build everything ourselves and not outsource anything, we have created a whole branding, website, content and more between the 3 of us. Every single detail has had a lot of love poured into it - we’re really proud of it and hope you enjoy it too :)</p>
        <p>Starting with a selection of unique art prints, we hope to grow and involve your guys’ work in the future. If you make something, anything, and would like a platform for this then reach out to us!</p>
        <br />
        <p>Lots of love,</p>
        <p>Holly, Issy, Leah</p>
        <p>X</p>
      </div>
      <br />
      <br />
      <Footer />
    </section>
  );
}

export default About;
